import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const keycloak = defineConnector({
  identifier: "keycloak",
  name: "Keycloak",
  tagLine: "Identity and access management",
  logo,
  protocol: "http",
  tags: ["identity"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get an admin API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create a service account in your Keycloak realm with appropriate admin roles, then generate an access token. Alternatively, use a personal access token from your admin account.",
        },
      ],
    },
    {
      title: "Enter your Keycloak details",
      items: [
        {
          kind: "url",
          label: "Keycloak server URL",
          required: true,
          placeholder: "https://keycloak.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Keycloak server.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/admin/realms`,
  },
});
